// Feature Cards - Equalize card heights on all breakpoints
document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('[data-feature-cards-section]');

  sections.forEach(function (section) {
    // Equalize card heights on all breakpoints
    function equalizeCardHeights() {
      const cards = section.querySelectorAll('.feature-card');

      // Reset heights first
      cards.forEach(function (card) {
        card.style.height = 'auto';
      });

      // Find tallest card
      let maxHeight = 0;
      cards.forEach(function (card) {
        const height = card.offsetHeight;
        if (height > maxHeight) {
          maxHeight = height;
        }
      });

      // Set all cards to same height
      cards.forEach(function (card) {
        card.style.height = maxHeight + 'px';
      });
    }

    // Equalize on load
    equalizeCardHeights();

    // Equalize on resize
    window.addEventListener('resize', equalizeCardHeights);
  });
});
